import "../less/mb-finiper-felicita2020.less";

import $ from "jquery";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl";
import AssociaNumeroCtrl from "./controllers/AssociaNumeroCtrl";
import CompletaDatiCtrl from "./controllers/CompletaDatiCtrl";
import DefaultCtrl from "./controllers/DefaultCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import FormCtrl from "./controllers/FormCtrl";
import HaiVintoCtrl from "./controllers/HaiVintoCtrl";
import { SmartComponentManager } from "smart-component-js";
import VisualParallaxComponent from "./components/VisualParallaxComponent";

SmartComponentManager.registerComponents({
  DefaultCtrl,
  VisualParallaxComponent,
  FeedbackModalComponent,
  FormCtrl,
  AreaPersonaleCtrl,
  CompletaDatiCtrl,
  HaiVintoCtrl,
  AssociaNumeroCtrl,
});

$(document).ready(() => {
  let $body = $(".mb-finiper-felicita2020");

  SmartComponentManager.initComponentByName($body[0], $body.attr("component"));
});
